<table class="sd-table">
  <tr *ngFor="let row of data.rows">
    <td
      *ngFor="let cell of row.cells"
      class="sd-table-cell sd-table-cell--bg-transparent"
      [attr.rowspan]="cell | rowspan"
      [attr.colspan]="cell | colspan"
      [innerHTML]="cell.content">
    </td>
  </tr>
</table>

